import { render, staticRenderFns } from "./auto-redirect.vue?vue&type=template&id=13c96635&"
import script from "./auto-redirect.vue?vue&type=script&lang=js&"
export * from "./auto-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports